// import React, { useRef, useEffect, useState } from 'react';
// import { Chart, registerables } from 'chart.js';
// import { Dropdown, Button } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';

// Chart.register(...registerables);

// const BarChart = (props) => {
//     const chartRef = useRef(null);
//     const chartInstance = useRef(null);
//     const [selectedYear, setSelectedYear] = useState('2023');

//     const dataForYear = {
//         '2023': [12, 19, 3, 5, 2, 3, 9, 15, 13, 8, 5, 18],
//         '2024': [10, 14, 6, 7, 2, 4, 12, 18, 17, 6, 9, 21],
//     };

//     useEffect(() => {
//         const ctx = chartRef.current.getContext('2d');

//         // Destroy the previous chart instance if it exists
//         if (chartInstance.current) {
//             chartInstance.current.destroy();
//         }

//         chartInstance.current = new Chart(ctx, {
//             type: 'bar',
//             data: {
//                 labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//                 datasets: [
//                     {
//                         label: 'Customer Details',
//                         data: dataForYear[selectedYear],
//                         backgroundColor: 'rgba(52, 58, 64, 1)',
//                         borderColor: 'rgba(52, 58, 64, 1)',
//                         borderWidth: 1,
//                         borderRadius: 4,
//                         borderSkipped: false,
//                     },
//                 ],
//             },
//             options: {
//                 scales: {
//                     y: {
//                         beginAtZero: true,
//                     },
//                 },
//                 plugins: {
//                     tooltip: {
//                         callbacks: {
//                             label: function (tooltipItem) {
//                                 const data = [
//                                     '1. Company1',
//                                     '2. Company2',
//                                     '3. Company3',
//                                     '4. Company4',
//                                 ];
//                                 return data.join('\n');
//                             },
//                         },
//                     },
//                 },
//                 // Adjust bar width
//                 barPercentage: 0.5,
//                 categoryPercentage: 0.5,
//             },
//         });

//         // Cleanup function to destroy the chart instance on unmount
//         return () => {
//             if (chartInstance.current) {
//                 chartInstance.current.destroy();
//             }
//         };
//     }, [selectedYear]);

//     const handleYearChange = (year) => {
//         setSelectedYear(year);
//     };

//     const downloadChart = () => {
//         const link = document.createElement('a');
//         link.href = chartRef.current.toDataURL('image/png');
//         link.download = 'chart.png';
//         link.click();
//     };

//     return (
//         <div className="barchart-container">
//             <div className="d-flex justify-content-between align-items-center">
//                 <h6>{props.moduleName}</h6>
//                 <div className="d-flex align-items-center">
//                     <Dropdown onSelect={handleYearChange}>
//                         <Dropdown.Toggle id="dropdown-basic">
//                             {selectedYear}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu  className="custom-dropdown-menu">
//                             <Dropdown.Item eventKey="2023">2023</Dropdown.Item>
//                             <Dropdown.Item eventKey="2024">2024</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown onSelect={handleYearChange}>
//                         <Dropdown.Toggle id="dropdown-basic">
//                             {selectedYear}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu  className="custom-dropdown-menu">
//                             <Dropdown.Item eventKey="2023">2023</Dropdown.Item>
//                             <Dropdown.Item eventKey="2024">2024</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown onSelect={handleYearChange}>
//                         <Dropdown.Toggle id="dropdown-basic">
//                             {selectedYear}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu  className="custom-dropdown-menu">
//                             <Dropdown.Item eventKey="2023">2023</Dropdown.Item>
//                             <Dropdown.Item eventKey="2024">2024</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown onSelect={handleYearChange}>
//                         <Dropdown.Toggle id="dropdown-basic">
//                             {selectedYear}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu  className="custom-dropdown-menu">
//                             <Dropdown.Item eventKey="2023">2023</Dropdown.Item>
//                             <Dropdown.Item eventKey="2024">2024</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     {/* <Button variant="primary" onClick={downloadChart} className="ml-2">
//             Download
//           </Button> */}
//                 </div>
//             </div>
//             <canvas ref={chartRef} />
//         </div>
//     );
// };

// export default BarChart;



import React, { useRef, useEffect, useState, useImperativeHandle } from 'react';
import { Chart, registerables } from 'chart.js';
import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { loadCustomerDetailsChartData, loadLeaveDashboardLeaveTypeChartData, loadLeaveTypeDropdownData, loadLicenceDashboardBarchartLicenseDetailsData } from '../../redux/action';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { jsPDF } from 'jspdf';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, HeadingLevel, ImageRun } from "docx";
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import { useLocation } from 'react-router-dom';

Chart.register(...registerables);

// const BarChart = (props) => {
const BarChart = React.forwardRef((props, ref) => {
    let dispatch = useDispatch();

    const { getCustomerDetailsChartData } = useSelector((state) => state.data);
    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { getLicenceDashboardBarChartlicenceDetailsData } = useSelector((state) => state.data);
    const { leaveDashboardLeaveTypeChartData } = useSelector((state) => state.data);
    const { getLeaveTypeDropdown } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null;
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null;

    const location = useLocation();
    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString()); // Default to current year
    const [selectedMonth, setSelectedMonth] = useState('Jan');
    const [selectedCompany, setSelectedCompany] = useState({
        value: storedCompanyId,
        label: storedCompanyName,
    });
    const [selectedLeaveType, setSelectedLeaveType] = useState();
    const [selectedLeaveMonth, setSelectedLeaveMonth] = useState();

    const dataForYear = {
        '2023': [22, 19, 13, 25, 2, 3, 9, 15, 13, 8, 5, 18],
        '2024': [10, 14, 6, 7, 2, 4, 12, 18, 17, 6, 9, 21],
    };

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const companies = ['Company1', 'Company2', 'Company3', 'Company4'];
    // const leaveTypes = ['Annual', 'Sick', 'Unpaid', 'Other'];

    const monthDropdown = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' }
    ];

    // Function to generate year range from startYear to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear(); // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const yearOptions = generateYearRange(2022); // Generate years from 2022 to the current year

    useEffect(() => {
        if (location.pathname === '/attendanceDashboard') {
            dispatch(loadLeaveTypeDropdownData());
        }
    }, [location.pathname])

    useEffect(() => {
        if (location.pathname === '/dashboard' || location.pathname === '/') {
            if (selectedYear) {
                dispatch(loadCustomerDetailsChartData(selectedYear.value));
            }
        } else if (location.pathname === '/licenceDashboard') {
            if (selectedCompany && selectedYear) {
                dispatch(loadLicenceDashboardBarchartLicenseDetailsData(selectedCompany.value, selectedYear.value));
            }
        }
    }, [selectedYear, selectedCompany, dispatch, location.pathname]);

    useEffect(() => {
        if (
            location.pathname === '/attendanceDashboard'
            // &&
            // selectedLeaveMonth &&
            // selectedYear &&
            // selectedLeaveType
        ) {
            dispatch(
                loadLeaveDashboardLeaveTypeChartData(
                    selectedLeaveMonth?.value,
                    selectedYear,
                    selectedLeaveType
                )
            );
        }
    }, [location.pathname, selectedLeaveMonth, selectedYear, selectedLeaveType]);

    useEffect(() => {
        if (!getCustomerDetailsChartData && !getLicenceDashboardBarChartlicenceDetailsData) return;
        const ctx = chartRef.current.getContext('2d');

        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        const chartData = location.pathname === '/licenceDashboard'
            ? getLicenceDashboardBarChartlicenceDetailsData.map(item => item.NoOfLicenses)
            : Object.values(getCustomerDetailsChartData || {});

        chartInstance.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: location.pathname === '/licenceDashboard'
                    ? getLicenceDashboardBarChartlicenceDetailsData.map(item => item.Year)
                    : Object.keys(getCustomerDetailsChartData || {}),
                datasets: [
                    {
                        label: location.pathname === '/licenceDashboard' ? 'License Details' : props.label,
                        data: chartData,
                        backgroundColor: 'rgba(52, 58, 64, 1)',
                        borderColor: 'rgba(52, 58, 64, 1)',
                        borderWidth: 1,
                        borderRadius: 4,
                        borderSkipped: false,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        grid: { display: false },
                    },
                    y: {
                        grid: { display: true, borderColor: 'rgba(246, 246, 246, 1)', borderWidth: 1, lineWidth: 0.5 },
                        beginAtZero: true,
                    },
                },
                plugins: {
                    legend: {
                        onClick: () => { },
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                return `${tooltipItem.label}: ${tooltipItem.raw}`;
                            },
                        },
                    },
                },
                barPercentage: 0.4,
                categoryPercentage: 0.4,
            },
        });

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [getCustomerDetailsChartData, getLicenceDashboardBarChartlicenceDetailsData, selectedYear, selectedCompany, location.pathname]);

    useEffect(() => {
        // Only run if on attendance dashboard
        if (location.pathname !== '/attendanceDashboard') return;

        if (!leaveDashboardLeaveTypeChartData || leaveDashboardLeaveTypeChartData.length === 0) return;

        const ctx = chartRef.current.getContext('2d');

        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        // 1️⃣ Extract month labels
        const labels = leaveDashboardLeaveTypeChartData.map(item => item.MonthName);

        // 2️⃣ Get all unique leave type names
        const leaveTypes = [
            ...new Set(
                leaveDashboardLeaveTypeChartData
                    .flatMap(item => item.LeaveDetails.map(ld => ld.LeaveTypeName))
            )
        ];

        // 3️⃣ Build datasets for each leave type
        const datasets = leaveTypes.map((type, idx) => ({
            label: type,
            data: leaveDashboardLeaveTypeChartData.map(item => {
                const leaveDetail = item.LeaveDetails.find(ld => ld.LeaveTypeName === type);
                return leaveDetail ? leaveDetail.TotalLeaves : 0;
            }),
            backgroundColor: `hsl(${(idx * 50) % 360}, 70%, 50%)`, // distinct colors
            borderRadius: 4,
            borderSkipped: false
        }));

        chartInstance.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: { grid: { display: false } },
                    y: {
                        grid: { display: true, borderColor: 'rgba(246, 246, 246, 1)', borderWidth: 1, lineWidth: 0.5 },
                        beginAtZero: true
                    }
                },
                plugins: {
                    legend: { onClick: () => { } },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
                            }
                        }
                    }
                },
                barPercentage: 0.4,
                categoryPercentage: 0.4
            }
        });

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [leaveDashboardLeaveTypeChartData, selectedYear, location.pathname]);

    // // Chart data and options
    // useEffect(() => {
    //     if (!getCustomerDetailsChartData) return;  // If data isn't available yet, skip chart creation

    //     const ctx = chartRef.current.getContext('2d');

    //     if (chartInstance.current) {
    //         chartInstance.current.destroy();
    //     }

    //     // Ensure the data is in the correct format (array for each month)
    //     const monthData = months.map(month => getCustomerDetailsChartData[month] || 0); // Use 0 if no data for that month

    //     chartInstance.current = new Chart(ctx, {
    //         type: 'bar',
    //         data: {
    //             labels: months,
    //             datasets: [
    //                 {
    //                     label: props.label,
    //                     data: monthData,
    //                     backgroundColor: 'rgba(52, 58, 64, 1)',
    //                     borderColor: 'rgba(52, 58, 64, 1)',
    //                     borderWidth: 1,
    //                     borderRadius: 4,
    //                     borderSkipped: false,
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             scales: {
    //                 x: {
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 y: {
    //                     grid: {
    //                         display: true,
    //                         borderColor: 'rgba(246, 246, 246, 1)',
    //                         borderWidth: 0.5,
    //                         lineWidth: 0.5,
    //                     },
    //                     beginAtZero: true,
    //                 },
    //             },
    //             plugins: {
    //                 legend: {
    //                     onClick: (e, legendItem, legend) => {
    //                         // No action to hide the dataset when clicking the legend
    //                         return;
    //                     },
    //                 },
    //                 tooltip: {
    //                     callbacks: {
    //                         label: function (tooltipItem) {
    //                             const month = months[tooltipItem.dataIndex];
    //                             return `${month}: ${tooltipItem.raw}`; // Show month and value
    //                         },
    //                     }
    //                 }
    //             },
    //             barPercentage: 0.3,
    //             categoryPercentage: 0.5,
    //         },
    //     });

    //     return () => {
    //         if (chartInstance.current) {
    //             chartInstance.current.destroy();
    //         }
    //     };
    // }, [getCustomerDetailsChartData, selectedYear, selectedMonth, selectedCompany, selectedLeaveType]);

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
    };

    const handleYearChange = (year) => {
        setSelectedYear(year);
    };

    const handleMonthChange = (month) => {
        setSelectedMonth(month);
    };

    const handleCompanyChange = (company) => {
        setSelectedCompany(company);
    };

    const handleLeaveTypeChange = (leaveType) => {
        // console.log(leaveType.label, 'leaveType.label')
        setSelectedLeaveType(leaveType.label);
    };

    const handleLeaveMonthChange = (month) => {
        setSelectedLeaveMonth(month);
    }

    // Use `useImperativeHandle` to expose methods to the parent component
    useImperativeHandle(ref, () => ({
        handleDownloadExcel: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard ? getLicenceDashboardBarChartlicenceDetailsData : getCustomerDetailsChartData;

            const chartDataFormatted = isLicenceDashboard
                ? chartData.map(item => ({
                    Year: item.Year,
                    NoOfLicenses: item.NoOfLicenses,
                }))
                : Object.keys(chartData).map(month => ({
                    Month: month,
                    Value: chartData[month] || 0,
                }));

            // Generate the chart image as a base64 string
            const chartImage = chartInstance.current.toBase64Image();

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(isLicenceDashboard ? 'License Data' : 'Customer Data');

            // Set up columns based on whether it's license or customer data
            worksheet.columns = isLicenceDashboard
                ? [
                    { header: 'Year', key: 'Year', width: 15 },
                    { header: 'NoOfLicenses', key: 'NoOfLicenses', width: 15 },
                ]
                : [
                    { header: 'Month', key: 'Month', width: 15 },
                    { header: 'Value', key: 'Value', width: 10 },
                ];

            // Add rows to the worksheet based on the formatted data
            chartDataFormatted.forEach(data => worksheet.addRow(data));

            // Add the chart image to the worksheet
            const imageId = workbook.addImage({
                base64: chartImage, // Base64 image string
                extension: 'png', // Adjust the extension as per your chart type
            });

            // Position the image in the worksheet (e.g., at cell A1, stretching it a bit)
            worksheet.addImage(imageId, {
                tl: { col: 0.5, row: 0.5 }, // Top-left corner of the image
                ext: { width: 500, height: 300 }, // Size of the image (width x height in pixels)
            });

            // Generate and download the Excel file
            workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                saveAs(blob, `${isLicenceDashboard ? 'License' : 'Customer'}_Data_with_Chart.xlsx`);
            }).catch(error => {
                console.error('Error downloading Excel file:', error);
            });
        },
        handleDownloadPDF: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard ? getLicenceDashboardBarChartlicenceDetailsData : getCustomerDetailsChartData;

            const chartDataFormatted = isLicenceDashboard
                ? chartData.map(item => ({
                    Year: item.Year,
                    NoOfLicenses: item.NoOfLicenses,
                }))
                : Object.keys(chartData).map(month => ({
                    Month: month,
                    Value: chartData[month] || 0,
                }));

            // Create a new PDF document
            const doc = new jsPDF();

            // Generate chart image as base64
            const chartImage = chartInstance.current.toBase64Image();

            // Add chart image to PDF
            const imageWidth = 180; // Width of the image in the PDF
            const imageHeight = 100; // Height of the image in the PDF
            doc.addImage(chartImage, 'PNG', 15, 10, imageWidth, imageHeight);

            // Add some space between the chart and the table
            let startY = 120;

            // Define columns for the table
            const columns = isLicenceDashboard
                ? [
                    { header: 'Year', dataKey: 'Year' },
                    { header: 'NoOfLicenses', dataKey: 'NoOfLicenses' },
                ]
                : [
                    { header: 'Month', dataKey: 'Month' },
                    { header: 'Value', dataKey: 'Value' },
                ];

            // Add table data to PDF using `jspdf-autotable`
            doc.autoTable({
                head: [columns.map(col => col.header)], // Header row
                body: chartDataFormatted.map(item => Object.values(item)), // Table data
                startY: startY, // Start position below the chart
                theme: 'grid', // Grid theme for better styling
                styles: {
                    fontSize: 10,
                    cellPadding: 2,
                },
                headStyles: {
                    fillColor: [0, 122, 204], // Blue header background
                    textColor: [255, 255, 255], // White header text
                },
            });

            // Save the PDF
            doc.save(`${isLicenceDashboard ? 'License' : 'Customer'}_Data_with_Chart.pdf`);
        },
        handleDownloadWord: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard ? getLicenceDashboardBarChartlicenceDetailsData : getCustomerDetailsChartData;

            if (!chartData || !chartInstance.current) return;

            // Format the data based on the dashboard type
            const chartDataFormatted = isLicenceDashboard
                ? chartData.map((data) => ({
                    Year: data.Year,
                    NoOfLicenses: data.NoOfLicenses,
                }))
                : months.map((month) => ({
                    Month: month,
                    Value: chartData[month] || 0,
                }));

            // Convert the chart to a Base64 image and prepare the byte array
            const chartImage = chartInstance.current.toBase64Image();
            const base64Data = chartImage.split(',')[1];
            const byteArray = new Uint8Array(
                atob(base64Data)
                    .split('')
                    .map((char) => char.charCodeAt(0))
            );

            // Create table rows dynamically based on the formatted data
            const tableRows = chartDataFormatted.map((data) => {
                return new TableRow({
                    children: isLicenceDashboard
                        ? [
                            new TableCell({
                                children: [new Paragraph(data.Year.toString())],
                            }),
                            new TableCell({
                                children: [new Paragraph(data.NoOfLicenses.toString())],
                            }),
                        ]
                        : [
                            new TableCell({
                                children: [new Paragraph(data.Month)],
                            }),
                            new TableCell({
                                children: [new Paragraph(data.Value.toString())],
                            }),
                        ],
                });
            });

            // Set up the Word document structure
            const doc = new Document({
                sections: [
                    {
                        children: [
                            // Title
                            new Paragraph({
                                text: isLicenceDashboard
                                    ? 'License Details Chart'
                                    : 'Customer Details Chart',
                                heading: HeadingLevel.TITLE,
                            }),

                            // Table with dynamic rows
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: isLicenceDashboard
                                            ? [
                                                new TableCell({
                                                    children: [new Paragraph('Year')],
                                                    shading: { fill: 'CCCCCC' },
                                                }),
                                                new TableCell({
                                                    children: [new Paragraph('NoOfLicenses')],
                                                    shading: { fill: 'CCCCCC' },
                                                }),
                                            ]
                                            : [
                                                new TableCell({
                                                    children: [new Paragraph('Month')],
                                                    shading: { fill: 'CCCCCC' },
                                                }),
                                                new TableCell({
                                                    children: [new Paragraph('Value')],
                                                    shading: { fill: 'CCCCCC' },
                                                }),
                                            ],
                                    }),
                                    ...tableRows,
                                ],
                            }),

                            // Chart Section
                            new Paragraph({
                                text: 'Chart:',
                                spacing: { before: 400, after: 200 },
                            }),
                            new Paragraph({
                                children: [
                                    new ImageRun({
                                        data: byteArray,
                                        transformation: {
                                            width: 500,
                                            height: 300,
                                        },
                                    }),
                                ],
                            }),
                        ],
                    },
                ],
            });

            // Generate and download the Word file
            Packer.toBlob(doc)
                .then((blob) => {
                    saveAs(blob, `${isLicenceDashboard ? 'License' : 'Customer'}_Details_Chart.docx`);
                })
                .catch((error) => {
                    console.error('Error generating Word document:', error);
                });
        },
        handlePrint: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard ? getLicenceDashboardBarChartlicenceDetailsData : getCustomerDetailsChartData;

            if (!chartData || !chartInstance.current) return;

            // Format the data dynamically based on the dashboard type
            const chartDataFormatted = isLicenceDashboard
                ? chartData.map((data) => ({
                    Year: data.Year,
                    NoOfLicenses: data.NoOfLicenses,
                }))
                : months.map((month) => ({
                    Month: month,
                    Value: chartData[month] || 0,
                }));

            // Get the chart image
            const chartImage = chartInstance.current.toBase64Image();

            // Generate a printable HTML structure
            const printableContent = `
                <html>
                    <head>
                        <title>Print Chart</title>
                        <style>
                            body {
                                font-family: Arial, sans-serif;
                                margin: 20px;
                            }
                            h1 {
                                text-align: center;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 20px;
                            }
                            th, td {
                                border: 1px solid #ccc;
                                padding: 8px;
                                text-align: center;
                            }
                            th {
                                background-color: #f4f4f4;
                            }
                            img {
                                display: block;
                                margin: 20px auto;
                                max-width: 100%;
                            }
                        </style>
                    </head>
                    <body>
                        <h1>${isLicenceDashboard ? 'License Details Chart' : 'Customer Details Chart'}</h1>
                        <img src="${chartImage}" alt="Chart Image" />
                        <table>
                            <thead>
                                <tr>
                                    ${isLicenceDashboard
                    ? '<th>Year</th><th>No Of Licenses</th>'
                    : '<th>Month</th><th>Value</th>'
                }
                                </tr>
                            </thead>
                            <tbody>
                                ${chartDataFormatted
                    .map((data) =>
                        isLicenceDashboard
                            ? `<tr><td>${data.Year}</td><td>${data.NoOfLicenses}</td></tr>`
                            : `<tr><td>${data.Month}</td><td>${data.Value}</td></tr>`
                    )
                    .join('')}
                            </tbody>
                        </table>
                        <script>
                            window.onload = function() {
                                window.print();
                            }
                        </script>
                    </body>
                </html>
            `;

            // Open the printable content in a new window
            const printWindow = window.open("", "_blank");
            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write(printableContent);
                printWindow.document.close();
            } else {
                console.error("Failed to open print window.");
            }
        },
        handleDownloadImage: () => {
            const isLicenceDashboard = location.pathname === '/licenceDashboard';
            const chartData = isLicenceDashboard ? getLicenceDashboardBarChartlicenceDetailsData : getCustomerDetailsChartData;

            if (!chartData || !chartInstance.current) return;

            // Format the data dynamically based on the dashboard type
            const chartDataFormatted = isLicenceDashboard
                ? chartData.map((data) => ({
                    Year: data.Year,
                    NoOfLicenses: data.NoOfLicenses,
                }))
                : months.map((month) => ({
                    Month: month,
                    Value: chartData[month] || 0,
                }));

            // Get the chart image as a base64 string
            const chartImage = chartInstance.current.toBase64Image();

            // Create the HTML structure with the chart image and table
            const printableContent = `
                <html>
                    <head>
                        <title>${isLicenceDashboard ? 'License Details' : 'Customer Details'} Chart</title>
                        <style>
                            body {
                                font-family: Arial, sans-serif;
                                margin: 20px;
                            }
                            h1 {
                                text-align: center;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 20px;
                            }
                            th, td {
                                border: 1px solid #ccc;
                                padding: 8px;
                                text-align: center;
                            }
                            th {
                                background-color: #f4f4f4;
                            }
                            img {
                                display: block;
                                margin: 20px auto;
                                max-width: 100%;
                            }
                        </style>
                    </head>
                    <body>
                        <h1>${isLicenceDashboard ? 'License Details Chart' : 'Customer Details Chart'}</h1>
                        <img src="${chartImage}" alt="Chart Image" id="chartImage" />
                        <table>
                            <thead>
                                <tr>
                                    ${isLicenceDashboard
                    ? '<th>Year</th><th>No Of Licenses</th>'
                    : '<th>Month</th><th>Value</th>'}
                                </tr>
                            </thead>
                            <tbody>
                                ${chartDataFormatted
                    .map((data) =>
                        isLicenceDashboard
                            ? `<tr><td>${data.Year}</td><td>${data.NoOfLicenses}</td></tr>`
                            : `<tr><td>${data.Month}</td><td>${data.Value}</td></tr>`
                    )
                    .join('')}
                            </tbody>
                        </table>
                    </body>
                </html>
            `;

            // Create a new window for capturing the HTML as an image
            const printWindow = window.open("", "_blank");
            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write(printableContent);
                printWindow.document.close();

                // Use html2canvas to capture the content as an image
                printWindow.onload = () => {
                    const elementToCapture = printWindow.document.body;
                    html2canvas(elementToCapture).then((canvas) => {
                        // Convert the canvas to an image
                        const imageData = canvas.toDataURL("image/png");

                        // Create a link to download the image
                        const link = document.createElement("a");
                        link.href = imageData;
                        link.download = `${isLicenceDashboard ? 'License_Details_Chart' : 'Customer_Details_Chart'}.png`;
                        link.click();

                        // Close the print window after download
                        printWindow.close();
                    }).catch((error) => {
                        console.error("Error capturing the image:", error);
                    });
                };
            } else {
                console.error("Failed to open print window.");
            }
        },
    }));

    return (
        <div className="barchart-container">
            <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '10px' }}>
                <h6>{props.moduleName}</h6>
                <div className="d-flex align-items-center gap-2">
                    {props.showTypeNameMonth && <div className="d-flex align-items-center gap-2">
                        <Dropdown onSelect={(eventKey) => handleLeaveTypeChange(JSON.parse(eventKey))}>
                            <Dropdown.Toggle id="dropdown-leave-type">
                                {selectedLeaveType || 'Leave Type'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {getLeaveTypeDropdown.map(type => (
                                    <Dropdown.Item key={type} eventKey={JSON.stringify(type)}>
                                        {type.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>

                        {/* <Dropdown onSelect={handleCompanyChange}>
                            <Dropdown.Toggle id="dropdown-company">
                                {selectedCompany}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {companies.map(company => (
                                    <Dropdown.Item key={company} eventKey={company}>
                                        {company}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown> */}

                        <Dropdown onSelect={(eventKey) => handleLeaveMonthChange(JSON.parse(eventKey))}>
                            <Dropdown.Toggle id="dropdown-month">
                                {/* {selectedLeaveMonth || 'Month'} */}
                                {selectedLeaveMonth?.label || "Month"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {monthDropdown.map(month => (
                                    <Dropdown.Item key={month} eventKey={JSON.stringify(month)}>
                                        {month.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>}
                    {props.showCompany && (<Dropdown>
                        <Dropdown.Toggle id='dropdown-company'>
                            {selectedCompany?.label || 'Select Company'}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {getCompanyDropdown.map((option) => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleCompanySelect(option)}
                                    active={selectedCompany.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>)}
                    {props.showYear && (
                        <Dropdown onSelect={handleYearChange}>
                            <Dropdown.Toggle id="dropdown-year">
                                {selectedYear}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {yearOptions.map((year) => (
                                    <Dropdown.Item key={year.value} eventKey={year.value}>
                                        {year.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                </div>
            </div>
            <div className="barchart-canvas-container">
                <canvas ref={chartRef} />
            </div>
        </div>
    );
});

export default BarChart;


